// @ts-strict
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, HostBinding, HostListener, Input, OnDestroy, ViewChild } from '@angular/core';
import { LMThemeService } from '@banner/lm-theme.service';
import { LMTooltipDirective } from 'directives/lm-tooltip.directive';

@Component({
  selector: 'lm-widget-title',
  standalone: false,
  template: `
    @if (icon) {
      @if (useSohoIcon) {
        <svg soho-icon icon="{{icon}}" class="widget-title-icon"/>
      } @else {
        <img ngSrc="{{iconUrl}}" class="widget-title-icon" width="30" height="30">
      }
      }<span #titleSpan lm-tooltip [content]="title">{{ title }}</span>`,
  styles: [`.widget-title-icon { margin-right: 12px; width: 30px; height: 30px; }`],

})
export class LMWidgetTitleComponent implements AfterViewInit, OnDestroy {
  @Input() title = '';
  @Input() icon = '';
  @Input() iconUrl = '';

  @ViewChild('titleSpan', { static: false }) titleSpan: ElementRef<HTMLElement>;
  @ViewChild(LMTooltipDirective, { static: false }) tooltip!: LMTooltipDirective;
  @HostBinding('style.display') display = 'inline-flex';
  @HostBinding('style.max-width') maxWidth = '100%';
  @HostBinding('attr.tabindex') tabindex = -1;
  @HostListener('focusin', [ '$event' ]) onFocus(event) {
    this.tooltip?.show();
  }

  public useSohoIcon = false;
  private widthObserver: ResizeObserver;

  constructor(
      private lmThemeService: LMThemeService,
      private cdr: ChangeDetectorRef
  ) {  }

  ngAfterViewInit() {
    const lplToSohoIcon = this.lmThemeService.lplIconToSohoXI(this.icon as LMIcon);
    this.useSohoIcon = lplToSohoIcon !== null && this.lmThemeService.isValidSohoIcon(this.icon);

    if (this.titleSpan) {
      this.checkTruncation();
      this.widthObserver = new ResizeObserver(() => this.checkTruncation());
      this.widthObserver.observe(this.titleSpan.nativeElement);
    }
  }

  ngOnDestroy() {
    this.widthObserver?.disconnect();
  }

  private checkTruncation() {
    const el = this.titleSpan.nativeElement;
    const truncated = el.scrollWidth > el.offsetWidth;
    const newTabindex = truncated ? 0 : -1;
    if (newTabindex !== this.tabindex) {
      this.tabindex = newTabindex;
      this.cdr.detectChanges();
    }
  }
}
